'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  // From TakeMeTour CI
  main: '#1cb6e6',
  blue: '#1cb6e6',
  blueLight: '#24cbed',
  black: '#283941',
  orange: '#e86a1a',
  orangeLight: '#ee8a21',
  orangeLighter: '#f3ac2a',
  yellow: '#f0bb42',
  green: '#0b6416',
  greenLighter: '#16c464',
  coral: '#ff4141',
  darkBlue: '#425e6c',
  darkBlueLighter: '#4f7183',
  gray: '#4a4a4a',
  blueGray: '#e2ecf0',
  blueGrayLighter: '#f0f5f7',
  blueGrayLighter2: '#f2f8fb',
  blueGrayDarker: '#abc5d0',
  blueGrayDark: '#baced8',
  borderGray: '#d8d8d8',
  darkGray: '#4a4a4a',
  darkGray1: '#979797',
  darkGray2: '#9b9b9b',
  disabledLight: '#eaf2f5',
  disableDark: '#39525f',
  lightGray: '#d0d0d0',
  lightGray1: '#d8d8d8',
  lightGray2: '#f2f2f2',
  lightGray3: '#dfe4e6',
  lightGray4: '#d9e3e7',

  // Not from CI
  red: '#d0021b',
  darkRed: '#d0021b',
  pink: '#f8d7da',
  white: '#ffffff',
  facebook: '#3b5998',
  google: '#4285f4',
  realBlack: '#000000',
  whatsApp: '#21d366',
  cardGradient: 'linear-gradient(118deg, #f6f9fb, #e2ebef)',
  font: 'Montserrat, Prompt, Tahoma, sans-serif !important',
  // Font size
  fontSize: {
    headline: 28,
    title: 24,
    subheader: 18,
    body: 13,
    menu: 14,
    caption: 12,
    button: 16
  },
  // Font Weight
  fontWeight: {
    thin: 100,
    extraLight: 200,
    light: 300,
    regular: 400,
    medium: 500,
    semiBold: 600,
    bold: 700,
    extraBold: 800,
    black: 900
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/theme/styled.theme.js
// module id = 1707
// module chunks = 47